// removed by extract-text-webpack-plugin
module.exports = {"form":"ExMNGecvixV7jl6ks50ny"};


//////////////////
// WEBPACK FOOTER
// ./ui/Form.module.css
// module id = 2418
// module chunks = 1